import NewCanvasMenu from './NewCanvasMenu'

export default NewCanvasMenu
